import styled, { FlattenSimpleInterpolation } from 'styled-components';
import { bodyLarge, bodyMedium, bodySmall } from '../paragraph';
import { Variant } from './list';

export const StyledUl = styled.ul<{
  variant: Variant;
}>`
  ${({ variant }): FlattenSimpleInterpolation | undefined => {
    if (variant === 'large') {
      return bodyLarge;
    }

    if (variant === 'medium') {
      return bodyMedium;
    }

    if (variant === 'small') {
      return bodySmall;
    }

    return;
  }}
`;
